export const environment = {
  production: false,
  authServiceUrl: 'https://spb-common-api-stage.internal.sparbankensyd.se/service',
  meetingPlannerApi: 'https://meeting-planner-test.internal.sparbankensyd.se/api',
  domain: 'secure-messages-test.foretag.sparbankensyd.se',
  testMode: true
}
